import * as React from 'react';

import SystemMessage from './SystemMessage';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  type: 'subcampaign_business_details_updated'
  | 'subcampaign_bank_details_updated'
  | 'subcampaign_no_business_details_provided'
};

class SystemChatMessageBankBusinessDetailsUpdate extends SystemMessage<Props> {
  render(): React.ReactNode {
    const { type } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon('business-bank-details-info-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            {__t(`system_message.${type}`)}
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageBankBusinessDetailsUpdate;
